import classes from './AboutUsPreviewBlock.module.css';

const AboutUsPreviewBlock = () => {
  return (
    <div
      className={
        classes.previewContainer + ' ' + ' flex flex-col justify-center'
      }
    >
      <div className={'px-10 md:mt-10 lg:mt-0 lg:px-20 '}>
        <p className="lg:block text-smTitlesForH md:text-mdTitlesForH lg:text-lgTitlesForH text-center">
          INVESTING AND IMPLEMENTING INNOVATE IDEAS EVERY DAY
        </p>
      </div>
    </div>
  );
};

export default AboutUsPreviewBlock;
